import { createFileRoute } from '@tanstack/react-router';
import { HelpPage } from '@/features/help/help-page';

export const Route = createFileRoute('/_app/_platform/help/')({
    staticData: { crumbs: [{ label: 'shell.help' }] },
    component: () => <HelpPage />,
});
